import React from 'react';
import styled from 'styled-components';

import {
  ConfirmationModal,
  ModalPosition,
  Container,
  Button,
  Checkbox,
} from 'ui/components/styled';

export const ConfirmRemoveUser = ({ params, confirmed, ...rest }) => (
  <ConfirmationModal
    padding="1.5rem 2rem 1.6rem"
    content={(props) => <ModalContent {...props} />} // force component re-render to reset confirmed value
    contentProps={{ params, confirmed }}
    position={ModalPosition.TOP_CENTER}
    top="33%"
    width="40%"
    maxWidth="550px"
    {...rest}
  />
);

const ModalContent = ({
  confirmed: initialConfirmed,
  params,
  onClose,
  onConfirm,
  preventConfirm,
}) => {
  const [confirmed, setConfirmed] = React.useState(initialConfirmed || false);

  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    setConfirmed(checked);
  };

  return (
    <>
      <>
        <Title mb="s">
          Are you sure you want to permanently delete user
          {params?.user?.name.full ? ` "${params.user.name.full}" ` : ''}?
        </Title>
        <Content mb="l">
          <Checkbox
            label="Yes, i am sure"
            fontSize="14px"
            checked={confirmed}
            onChange={handleCheckboxChange}
          />
        </Content>
      </>
      <Container flexDirection="row" justifyContent="flex-end">
        <Button variant="contrast-primary" boxShadow="none" width="40%" mr="m" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="danger"
          width="40%"
          boxShadow="none"
          onClick={onConfirm}
          disabled={preventConfirm || !confirmed}
        >
          Delete
        </Button>
      </Container>
    </>
  );
};

const Title = styled(Container)`
  font-weight: 500;
  color: #333;
`;

const Content = styled(Container)`
  font-weight: normal;
  font-size: 15px;
  letter-spacing: 0.04em;
  line-height: 26px;
  color: #888;
`;
